import { guardChildNodeByType } from '@utils/ast';

function extractComponentExcerpt(node, caption) {
  const fallback = node.getAttribute("id") ?? "";
  switch (node.tagName.toLowerCase()) {
    case "audio":
    case "component":
    case "ibook":
    case "ibook3":
    case "ibook4":
    case "taskenginelink":
    case "video":
      return extractTitleFromCaption(caption) ?? fallback;
    case "image":
      return extractTitleFromCaption(caption) ?? "Billede";
    case "complexcontent":
    case "simpletext":
    case "richtext":
      return extractTitleFromTextContent(node) ?? fallback;
    case "slider":
      return extractTitleFromSlider(node) ?? fallback;
    case "accordion":
      return extractTitleFromAccordion(node) ?? fallback;
    default:
      return fallback;
  }
}
function extractTitleFromCaption(caption) {
  var _a, _b, _c, _d, _e;
  if ((_a = caption.title) == null ? void 0 : _a.value) {
    return caption.title.value;
  }
  if ((_b = caption.description) == null ? void 0 : _b.value) {
    return getPlainTextExcerpt(caption.description.value);
  }
  if ((_c = caption.caption) == null ? void 0 : _c.value) {
    return caption.caption.value;
  }
  if ((_d = caption.authorOrArtist) == null ? void 0 : _d.value) {
    return caption.authorOrArtist.value;
  }
  if ((_e = caption.copyright) == null ? void 0 : _e.value) {
    return caption.copyright.value;
  }
  return void 0;
}
function extractTitleFromTextContent(node) {
  const contentNode = Array.from(node.childNodes).find(
    guardChildNodeByType("Value")
  );
  if (!contentNode || !contentNode.textContent) {
    return void 0;
  }
  return getPlainTextExcerpt(contentNode.textContent);
}
function extractTitleFromSlider(node) {
  return Array.from(node.childNodes).filter(guardChildNodeByType("SliderElement")).map((slide) => {
    var _a;
    return ((_a = slide.getAttribute("caption")) == null ? void 0 : _a.trim()) ?? "";
  }).find((caption) => caption.length > 0);
}
function extractTitleFromAccordion(node) {
  return Array.from(node.childNodes).filter(guardChildNodeByType("AccordionChild")).map(
    (panel) => {
      var _a;
      return decodeURIComponent(((_a = panel.getAttribute("title")) == null ? void 0 : _a.trim()) ?? "");
    }
  ).find((caption) => caption.length > 0);
}
function getPlainText(str) {
  const parserNode = document.createElement("div");
  parserNode.innerHTML = str;
  const plainStr = parserNode.innerText;
  return (plainStr == null ? void 0 : plainStr.replace(/\s+/g, " ").trim()) ?? "";
}
function getPlainTextExcerpt(str, maxLength = 35) {
  if (str.length < maxLength) {
    return str;
  }
  return getPlainText(str).substr(0, maxLength - 3) + "...";
}

export { extractComponentExcerpt };
//# sourceMappingURL=util.extract-component-excerpt.js.map
